export default "__VITE_ASSET__C1mbfc16__"